import { useRef } from "react";

export const useCommonSortFilterHook = (moduleName) => {
  const getSessionValue = (key, defaultValue) => sessionStorage.getItem(`${moduleName}_${key}`) || defaultValue;

  const getSessionJSON = (key, defaultValue) => {
    const item = sessionStorage.getItem(`${moduleName}_${key}`);
    return item ? JSON.parse(item) : defaultValue;
  };

  const setSessionValue = (key, value) => {
    const storedValue = typeof value === "object" ? JSON.stringify(value) : value;
    sessionStorage.setItem(`${moduleName}_${key}`, storedValue);
  };

  const currentPage = useRef(getSessionValue("currentPage", 1));
  const pageSize = useRef(getSessionValue("pageSize", 10));
  const sortData = useRef(getSessionJSON("sort", []));
  const filterData = useRef(getSessionJSON("filter", null));
  const search = useRef(getSessionValue("search", ""));

  const updateStateAndSession = (key, value, resetPage = false) => {
    if (resetPage) {
      currentPage.current = 1;
      setSessionValue("currentPage", 1);
    }
    if (key === "search") search.current = value;
    if (key === "sort") sortData.current = value;
    if (key === "filter") filterData.current = value;

    setSessionValue(key, value);
  };

  return {
    currentPage,
    pageSize,
    sortData,
    search,
    filterData,
    onSearch: (value) => updateStateAndSession("search", value, true),
    onSortData: (data) => updateStateAndSession("sort", data),
    onUpdatePage: (page, limit) => {
      currentPage.current = page;
      pageSize.current = limit;
      setSessionValue("currentPage", page);
      setSessionValue("pageSize", limit);
    },
    onFilterData: (data) => updateStateAndSession("filter", data, true),
  };
};
